// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin_mainContainer__SIeyj {
}

.admin_createContainer__CuEhD {
  background-color: #ffffff;
  box-shadow: 0 0 3px darkgray;
  border-radius: 5px;
  margin-bottom: 2rem;
}

.admin_buttonContainer__JH0R9 {
  display: flex;
  justify-content: end;
  margin-bottom: 2rem;
}

.admin_container__p3jea {
  padding-top: 110px;
  /*DELETE*/
  padding-left: var(--global-margin);
  /*DELETE*/
}

@media (max-width: 650px) {
  .admin_container__p3jea {
    padding-left: 20px;
  }

  .admin_crudContainer__-mlt- {
    padding-left: 20px !important;
  }

  .admin_crudText__D-7TM {
    display: none;
  }

  .admin_crudInputs__jCi-f {
    width: 95% !important;
  }

  .admin_halfContainer__rpwsu {
    flex-basis: 100% !important;
    padding-bottom: 1rem;
  }
}

.admin_crudContainer__-mlt- {
  padding-top: 120px;
  /*DELETE*/
  padding-left: var(--global-margin);
  /*DELETE*/

  display: flex;
  flex-direction: row;
}

.admin_crudText__D-7TM {
  width: 25%;
  text-align: left;
  margin-right: 1rem;
}

.admin_crudText__D-7TM div:first-child {
  font-size: medium;
  font-weight: 500;
  color: #4b556c;
}

.admin_crudText__D-7TM div:last-child {
  font-size: small;
  color: #6b7280;
}

.admin_crudInputs__jCi-f {
  width: 70%;
}

.admin_footer__wOXhP {
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: end;
  padding-right: 16px;
}

.admin_tableButton__PH5jK {
  background-color: #fff;
  box-shadow: #4b556c 0 0 2px;
  border-radius: 6px;
  padding: 8px 20px;
}

.admin_halfContainer__rpwsu {
  flex-basis: 48%;
}

.admin_link__ooBD6 {
  text-decoration: none;
}

.admin_link__ooBD6:hover {
  color: #2563eb;
}

.admin_activeLink__bMFO8 {
  text-decoration: none;
  color: #2563eb;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/admin/styles/admin.module.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kCAAkC;EAClC,SAAS;;EAET,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".mainContainer {\n}\n\n.createContainer {\n  background-color: #ffffff;\n  box-shadow: 0 0 3px darkgray;\n  border-radius: 5px;\n  margin-bottom: 2rem;\n}\n\n.buttonContainer {\n  display: flex;\n  justify-content: end;\n  margin-bottom: 2rem;\n}\n\n.container {\n  padding-top: 110px;\n  /*DELETE*/\n  padding-left: var(--global-margin);\n  /*DELETE*/\n}\n\n@media (max-width: 650px) {\n  .container {\n    padding-left: 20px;\n  }\n\n  .crudContainer {\n    padding-left: 20px !important;\n  }\n\n  .crudText {\n    display: none;\n  }\n\n  .crudInputs {\n    width: 95% !important;\n  }\n\n  .halfContainer {\n    flex-basis: 100% !important;\n    padding-bottom: 1rem;\n  }\n}\n\n.crudContainer {\n  padding-top: 120px;\n  /*DELETE*/\n  padding-left: var(--global-margin);\n  /*DELETE*/\n\n  display: flex;\n  flex-direction: row;\n}\n\n.crudText {\n  width: 25%;\n  text-align: left;\n  margin-right: 1rem;\n}\n\n.crudText div:first-child {\n  font-size: medium;\n  font-weight: 500;\n  color: #4b556c;\n}\n\n.crudText div:last-child {\n  font-size: small;\n  color: #6b7280;\n}\n\n.crudInputs {\n  width: 70%;\n}\n\n.footer {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: end;\n  padding-right: 16px;\n}\n\n.tableButton {\n  background-color: #fff;\n  box-shadow: #4b556c 0 0 2px;\n  border-radius: 6px;\n  padding: 8px 20px;\n}\n\n.halfContainer {\n  flex-basis: 48%;\n}\n\n.link {\n  text-decoration: none;\n}\n\n.link:hover {\n  color: #2563eb;\n}\n\n.activeLink {\n  text-decoration: none;\n  color: #2563eb;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `admin_mainContainer__SIeyj`,
	"createContainer": `admin_createContainer__CuEhD`,
	"buttonContainer": `admin_buttonContainer__JH0R9`,
	"container": `admin_container__p3jea`,
	"crudContainer": `admin_crudContainer__-mlt-`,
	"crudText": `admin_crudText__D-7TM`,
	"crudInputs": `admin_crudInputs__jCi-f`,
	"halfContainer": `admin_halfContainer__rpwsu`,
	"footer": `admin_footer__wOXhP`,
	"tableButton": `admin_tableButton__PH5jK`,
	"link": `admin_link__ooBD6`,
	"activeLink": `admin_activeLink__bMFO8`
};
export default ___CSS_LOADER_EXPORT___;
